// extracted by mini-css-extract-plugin
export default {"container":"datanotfound_container__RNC3I","img":"datanotfound_img__I5PaL","text":"datanotfound_text__PLyr8"};